import Axios from '../utils/Axios';

export type SectorType = {
  parent_store_sector_id: number;
  store_sector_id: number;
  depth: number;
  id_order: number;
  parent_sector_name: string | null;
  sector_name: string;
  sector_list: SectorType[];
  is_check: boolean;
};

const AdvertiseController = {
  // 업종 카테고리
  getSector: async (storeId: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/3/${storeId}/getSector`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[업종 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setSector: async (store_id: number, sector_list: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setSector';
      const oParams = {
        store_id: store_id,
        sector_list: sector_list,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[업종 저장 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default AdvertiseController;
